import React from 'react';
import { Trash2, Plus, Edit2, Target } from 'lucide-react';

export function SegmentsTab({ segments, onAdd, onEdit, onDelete }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-gray-400">{segments.length} segmento(s) cadastrado(s)</p>
        <button
          onClick={onAdd}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
        >
          <Plus size={18} />
          Novo Segmento
        </button>
      </div>

      <div className="grid gap-4">
        {segments.map(segment => (
          <div
            key={segment.id}
            className="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50 hover:border-gray-600 transition-colors"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                  <Target size={18} className="text-blue-400" />
                  {segment.name}
                </h3>
                {segment.description && (
                  <p className="text-gray-400 text-sm mt-1">{segment.description}</p>
                )}
                
                <div className="mt-4 space-y-2">
                  <div>
                    <span className="text-gray-500 text-xs uppercase">Personalidade da IA:</span>
                    <p className="text-gray-300 text-sm">{segment.ai_personality}</p>
                  </div>
                  <div>
                    <span className="text-gray-500 text-xs uppercase">Mensagens de Abertura:</span>
                    <ul className="text-gray-300 text-sm list-disc list-inside">
                      {segment.ai_opening_messages?.slice(0, 2).map((msg, idx) => (
                        <li key={idx}>{msg}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="flex gap-2">
                <button
                  onClick={() => onEdit(segment)}
                  className="p-2 rounded-lg bg-gray-700 hover:bg-gray-600 text-gray-300"
                  title="Editar"
                >
                  <Edit2 size={18} />
                </button>
                <button
                  onClick={() => onDelete(segment.id)}
                  className="p-2 rounded-lg bg-red-500/20 hover:bg-red-500/30 text-red-400"
                  title="Excluir"
                >
                  <Trash2 size={18} />
                </button>
              </div>
            </div>
          </div>
        ))}

        {segments.length === 0 && (
          <div className="text-center py-10 text-gray-500">
            <Target size={48} className="mx-auto mb-3 opacity-50" />
            <p>Nenhum segmento cadastrado</p>
            <p className="text-sm">Crie segmentos para organizar seus leads por tipo de negócio</p>
          </div>
        )}
      </div>
    </div>
  );
}
